import {
    createWelcomeMessage,
    deleteWelcomeMessage,
    getWelcomeMessages,
    updateWelcomeMessage,
} from "../../api/welcomeMessage";
import { toArray, toObject } from "../../utils/languageContent";

const welcomeMessage = {
    namespaced: true,
    state: {
        welcomeMessages: {
            count: 0,
            data: [],
            total: 0,
        },
    },
    getters: {
        getUndeleted: (state) => {
            return state.welcomeMessages.data.map((x) => toObject(x)).filter((p) => p.isDeleted === false);
        },
    },
    mutations: {
        SET_WELCOME_MESSAGES: (state, payload) => {
            state.welcomeMessages = payload;
        },
        ADD_WELCOME_MESSAGE: (state, payload) => {
            state.welcomeMessages.data.push(payload);
            state.welcomeMessages.total++;
        },
        UPDATE_WELCOME_MESSAGE: (state, payload) => {
            let welcomeMessage = state.welcomeMessages.data.find((p) => p._id === payload._id);
            welcomeMessage = payload;
        },
        DELETE_WELCOME_MESSAGE: (state, id) => {
            state.welcomeMessages.data = state.welcomeMessages.data.filter((r) => r._id !== id);
            state.welcomeMessages.total--;
        },
    },
    actions: {
        getWelcomeMessages({ commit }, payload) {
            return getWelcomeMessages(payload.perPage, payload.page).then((response) => {
                commit("SET_WELCOME_MESSAGES", response.data);
            });
        },
        getWelcomeMessage({ state }, id) {
            return state.welcomeMessages.data.map((x) => toObject(x)).find((p) => p._id === id);
        },
        createWelcomeMessage({ commit }, payload) {
            return createWelcomeMessage(toArray(payload)).then((response) => {
                const data = toObject(response.data);
                commit("ADD_WELCOME_MESSAGE", data);
                return Promise.resolve(data);
            });
        },
        updateWelcomeMessage({ commit }, payload) {
            return updateWelcomeMessage(payload._id, toArray(payload)).then((response) => {
                const data = toObject(response.data);
                commit("UPDATE_WELCOME_MESSAGE", data);
                return Promise.resolve(data);
            });
        },
        deleteWelcomeMessage({ commit }, id) {
            return deleteWelcomeMessage(id).then((response) => {
                commit("DELETE_WELCOME_MESSAGE", id);
                return Promise.resolve(response);
            });
        },
    },
};

export default welcomeMessage;
